module.exports = __webpack_public_path__ + "static/media/signup-image.4cbd1d2a.svg";